import { ENUM_STATUS_ATIVO } from 'utils/consts';
import { documentoMask } from 'utils/masks';
import { reloadVlibras } from './acessibilidade';

export const _validateObject = (objectError, setError) => {
  let isValid = true;
  Object.keys(objectError).forEach(key => {
    // SE NÃO TIVER ERRO, LIMPA O ERRO
    if (objectError[key] === null) {
      setError(key, { type: 'Clear', message: '' });
      // SE ERRO FOR UM OBJETO, CHAMA A FUNÇÃO DE VALIDAR
    } else if (typeof objectError[key] !== 'string') {
      const isObjectValid = _validateObject(objectError[key], setError);
      if (isValid && !isObjectValid) isValid = false;
      // SE TIVER ERRO E NÃO FOR OBJETO, SALVA O ERRO
    } else if (objectError[key]) {
      isValid = false;
      setError(key, { type: 'Custom', message: objectError[key] });
    }
  });

  return isValid;
};

export const exibirMensagemErroCampo = (errosValidations, setError) => {
  // VALIDA SE TODOS OS CAMPOS ESTÃO CORRETOS
  let isValid = _validateObject(errosValidations, setError);
  reloadVlibras();
  return isValid;
};

export const clearErroChange = (name, value, errors, setError) => {
  // LIMPA O ERRO DE UM CAMPO ESPECIFICO (SE TIVER)
  if (value && errors[name]) {
    setError(name, { type: 'Clear', message: '' });
  }
};

export const changeDocument = (event, name = 'documento') => {
  return {
    target: {
      name: name,
      value: documentoMask(event.target.value),
    },
  };
};

const isValid = value => {
  const validTypes = ['string', 'number'];
  const type = typeof value;
  return value !== null && value !== undefined && (validTypes.some(item => item === type) || Array.isArray(value));
};

export const valueOrDefaultValue = (value, defaultValue, mask) => {
  if (mask) {
    return isValid(value) ? mask(value) : mask(defaultValue);
  }
  return isValid(value) ? value : defaultValue;
};

export const validarExibirErrosCampos = (dodosInputs, funcValidar, setError) => {
  const erros = funcValidar(dodosInputs);
  return exibirMensagemErroCampo(erros, setError);
};

export const changeInput = (event, setValue, errors, setError) => {
  const { name, value } = event.target;
  setValue(name, value);
  clearErroChange(name, value, errors, setError);
  return { value, name, errors };
};

export const changeInputFilter = (e, setValue) => {
  const { value, name } = e.target;
  setValue(name, value);
};

export const converterAtivoFiltro = statusAtivo => {
  if (statusAtivo === '' || statusAtivo === undefined) return '';
  return statusAtivo === ENUM_STATUS_ATIVO?.ATIVO?.value ? 'true' : 'false';
};

export const separarEmail = email => {
  if (window.screen.width > 1550) return email;
  const novoEmail = email?.split('@');
  if (novoEmail?.length === 2) return `${novoEmail[0]} @${novoEmail[1]}`;
  return email;
};
